<!--
 * @Author: wjc
 * @Date: 2026-03-23 08:53:48
 * @LastEditors: wjc
 * @LastEditTime: 2026-03-24 11:55:00
 * @Description: 
-->
<template>
  <button
    v-show="isVisible"
    class="scroll-to-top right-32px bottom-15% wh-44px flex-center lt-sm:right-24px lt-sm:bottom-24px lt-sm:wh-72px fixed z-200 cursor-pointer rounded-full border border-white/80 bg-white/90 text-slate-600 shadow-[0_10px_30px_rgba(15,23,42,0.16)] backdrop-blur-sm transition-all duration-300 select-none hover:-translate-y-2 hover:border-blue-200 hover:bg-white hover:text-blue-600 hover:shadow-[0_16px_40px_rgba(15,23,42,0.2)] focus-visible:ring-2 focus-visible:ring-blue-500/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-none active:translate-y-0 active:scale-95"
    aria-label="返回顶部"
    @click="scrollToTop"
  >
    <i class="i-ep-arrow-up text-18px lt-sm:text-28px" aria-hidden="true"></i>
  </button>
</template>

<script setup lang="ts">
  defineOptions({
    name: 'ScrollToTop',
  })

  const props = withDefaults(defineProps<{ threshold?: number }>(), {
    threshold: 300,
  })

  const { y } = useWindowScroll()
  const isVisible = computed(() => y.value > props.threshold)

  const scrollToTop = () => {
    if (typeof window === 'undefined') return
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
</script>
